<app-colapsable [title]="'ASEGURADO'" [expanded]="expanded" ($expandedChange)="expandChange()">
  <div description class="colapsable-panel-description">
    <app-form-lablel
      *ngIf="data"
      class="adjusVisibilityMobile"
      [label]="'Nombre:'"
    ></app-form-lablel>
    <app-form-text
      *ngIf="data"
      class="adjusVisibilityMobile"
      [text]="data ? data?.Nombres + ' ' + data?.Apellidos : ''"
    >
    </app-form-text>
    <div class="spacer"></div>
    <app-form-lablel
      *ngIf="data"
      class="adjusVisibilityMobile"
      [label]="'Rut:'"
    ></app-form-lablel>
    <app-form-text
      *ngIf="data"
      class="adjusVisibilityMobile"
      [text]="formatRUT(data?.Rut)"
    ></app-form-text>
  </div>
  <div body [ngSwitch]="editMode">
    <app-mini-loader *ngIf="loading"></app-mini-loader>
    <app-error *ngIf="error"></app-error>

    <div id="resumen" class="card-grid" *ngIf="!editMode && !error && !loading">
      <div class="container-name data-pair resumen-grid-cell adjusVisibility">
        <span class="data-pair-label">Nombre</span>
        <span class="data-pair-value">{{
          data?.Nombres + ' ' + data?.Apellidos
        }}</span>
      </div>

      <div class="container-dni data-pair resumen-grid-cell adjusVisibility">
        <span class="data-pair-label">Rut</span>
        <span class="data-pair-value">{{ formatRUT(data?.Rut) }}</span>
      </div>

      <div class="container-phone data-pair resumen-grid-cell">
        <span class="data-pair-label">Teléfono particular</span>
        <span class="data-pair-value">{{
          '+56 ' + data?.Telefono || '-'
        }}</span>
        <!-- <span class="data-pair-value">{{data?.Telefono ? data?.Telefono  : null }}</span> -->
      </div>
      <div class="container-email data-pair resumen-grid-cell">
        <span class="data-pair-label">Correo electrónico</span>
        <span class="data-pair-value">{{ data?.Correo || '-' }}</span>
      </div>
      <div class="container-address data-pair resumen-grid-cell">
        <span class="data-pair-label">Dirección</span>
        <span class="data-pair-value">{{
          data?.Direccion ? data?.Direccion : null
        }}</span>
      </div>
      <div class="container-region adjust-margin data-pair resumen-grid-cell">
        <span class="data-pair-label">Región</span>
        <span class="data-pair-value">{{ data?.Region || '-' }}</span>
      </div>
      <div class="container-city adjust-margin data-pair resumen-grid-cell">
        <span class="data-pair-label">Ciudad</span>
        <span class="data-pair-value">{{ data?.Ciudad || '-' }}</span>
      </div>
      <div class="container-commune data-pair resumen-grid-cell">
        <span class="data-pair-label">Comuna</span>
        <span class="data-pair-value">{{
          data?.Comuna ? data?.Comuna : null
        }}</span>
      </div>
      <div
        class="container-account-type adjust-margin data-pair resumen-grid-cell"
      >
        <span class="data-pair-label">Tipo de Cuenta</span>
        <span class="data-pair-value">{{ data?.TipoCuenta || '-' }}</span>
      </div>
      <div class="container-bank data-pair resumen-grid-cell">
        <span class="data-pair-label">Banco</span>
        <span class="data-pair-value">{{ data?.Banco || '-' }}</span>
      </div>
      <div class="container-account-number data-pair resumen-grid-cell">
        <span class="data-pair-label">Número de Cuenta</span>
        <span class="data-pair-value">{{ data?.NumeroCuenta || '-' }}</span>
      </div>
      <div class="containerr-button" *ngIf="!hidebuttonModificar">
        <button (click)="onEditMode()" mat-stroked-button>
          Modificar Datos
        </button>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="card-grid combo-style" *ngIf="editMode">
        <div class="container-name data-pair resumen-grid-cell adjusVisibility">
          <span class="data-pair-label">Nombre</span>
          <span class="data-pair-value">{{
            data?.Nombres + ' ' + data?.Apellidos
          }}</span>
        </div>

        <div class="container-dni data-pair resumen-grid-cell adjusVisibility">
          <span class="data-pair-label">Rut</span>
          <span class="data-pair-value">{{ formatRUT(data?.Rut) }}</span>
        </div>

        <div class="adjusVisibility container-modify">MODIFICAR MIS DATOS</div>

        <div class="container-phone adjust-margin">
          <app-form-input-text
            [prefix]="+56"
            [maxlength]="9"
            [label]="'Teléfono particular'"
            formControlName="Telefono"
            [messageError]="getErrorMessage(form, 'Telefono')"
          ></app-form-input-text>
        </div>

        <div class="container-email">
          <app-form-input-text
            [label]="'Correo electrónico'"
            formControlName="Correo"
            [messageError]="getErrorMessage(form, 'Correo')"
          ></app-form-input-text>
        </div>

        <div class="container-address">
          <app-form-input-text
            [label]="'Dirección'"
            formControlName="Direccion"
            [messageError]="getErrorMessage(form, 'Direccion')"
          ></app-form-input-text>
        </div>

        <div class="container-region adjust-margin">
          <app-form-select
            formControlName="RegionCodigo"
            [label]="'Región'"
            [options]="regiones"
            [optionValue]="'CodigoRegion'"
            [optionDescription]="'Nombre'"
            [messageError]="getErrorMessage(form, 'RegionCodigo')"
            ($onChange)="regionOnChange($event)"
          >
          </app-form-select>
        </div>

        <div class="container-city adjust-margin">
          <app-form-select
            formControlName="CiudadCodigo"
            [label]="'Ciudad'"
            [options]="ciudades"
            [optionValue]="'CodigoCiudad'"
            [optionDescription]="'Nombre'"
            [messageError]="getErrorMessage(form, 'CiudadCodigo')"
            ($onChange)="ciudadOnChange($event)"
          >
          </app-form-select>
        </div>

        <div class="container-commune">
          <app-form-select
            formControlName="ComunaCodigo"
            [label]="'Comuna'"
            [options]="comunas"
            [optionValue]="'CodigoComuna'"
            [optionDescription]="'Nombre'"
            [messageError]="getErrorMessage(form, 'ComunaCodigo')"
          ></app-form-select>
        </div>

        <div class="container-account-type data-pair resumen-grid-cell">
          <span class="data-pair-label">Tipo de Cuenta</span>
          <span class="data-pair-value">{{
            data?.TipoCuenta ? data?.TipoCuenta : '-'
          }}</span>
        </div>

        <!-- <div class="container-bank data-pair resumen-grid-cell">
          <span class="data-pair-label">Banco</span>
          <span class="data-pair-value">{{ data?.Banco }}</span>
        </div> -->
        <div class="container-bank adjust-margin">
          <app-form-select
            formControlName="BancoCodigo"
            [label]="'Banco'"
            [options]="bancos"
            [optionValue]="'Codigo'"
            [optionDescription]="'NombreBanco'"
            [messageError]="getErrorMessage(form, 'BancoCodigo')"
          >
          </app-form-select>
        </div>

        <div class="container-account-number">
          <app-form-input-text
            [label]="'Número de cuenta'"
            [typeNumber]="true"
            [maxlength]="20"
            formControlName="NumeroCuenta"
            [messageError]="getErrorMessage(form, 'NumeroCuenta')"
          ></app-form-input-text>
        </div>

        <div class="containerr-button">
          <button
            (click)="offEditMode()"
            mat-stroked-button
            class="button-detail"
          >
            Cancelar
          </button>
          <button
            type="submit"
            mat-flat-button
            [disabled]="!form.valid || !form.dirty"
          >
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</app-colapsable>
